import { render, staticRenderFns } from "./DailyTasksPage.vue?vue&type=template&id=16ba4de8"
import script from "./DailyTasksPage.vue?vue&type=script&lang=js"
export * from "./DailyTasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports